/**
 * To reset IDs between unit tests:
 * ```
 * //@ts-ignore-next-line (resetIdGenerator is defined in the mock version of the module)
 * import { resetIdGenerator } from "/skyward.base.extensions.idGenerator""`
 * beforeEach(() => {
 *     resetIdGenerator();
 * });
 * ```
 */
// This is in a separate file from the rest of extensions.ts so that, when testing, we can reset the ID between tests
// We can only intercept calls to getIdGenerator() when it's imported, so we have to keep this separate from `autoIdGenerator`.
// Extensions.ts imports getIdGenerator from this file. Everything else should use the re-export from extensions.ts.

/**
* An object that generates unique id strings 
* @example
* const generator = skyward.extensions.getIdGenerator("popup", "_browse");
* generator.id // returns "popup0_browse"
* generator.getNewId() // returns "popup1_browse"
* generator.id // returns "popup1_browse"
* generator.getNewId() // returns "popup2_browse"
* @param prefix A string that will be prepended to the id string (before the counter)
* @param postfix A string that will be appended to the id string (after the counter)
* @param initialValue The initial value to use for the id counter
* @returns An IDGenerator based on the supplied arguments
*/
export function getIdGenerator(prefix: string, postfix = "", initialValue = 0)
{
    let counter = Number.isInteger(initialValue) ? initialValue : 0;
    return {
        get id()
        {
            return `${prefix}${counter}${postfix}`;
        },
        getNewId: function()
        {
            ++counter;
            return this.id;
        }
    };
}
